import { styled } from "@mui/material/styles";
import { Box, Typography } from "@mui/material";

export const StyledNotificationPanel = styled(Box)(({ theme }) => ({
  position: "fixed",
  right: "-600px",
  top: "35%",
  zIndex: 999,
  backgroundColor: theme.palette.neutral.black,
  opacity: 0.8,
  color: theme.palette.neutral.white,
  padding: "30px",
  borderRadius: "4px 0 0 4px",
  border: `1px solid ${theme.palette.neutral.black}`,
  maxWidth: "300px",
  fontSize: "14px",
  lineHeight: 1.5,
  transition: "right 0.3s ease-in-out",
  "&.visible": {
    right: "0",
  },
  "& p": {
    margin: "5px 0",
  },
}));

export const TimestampSection = styled(Box)(({ theme }) => ({
  marginBottom: theme.spacing(2),
}));

export const SourceTargetsSection = styled(Box)(({ theme }) => ({
  marginBottom: theme.spacing(1),
}));

export const DetailLabel = styled(Typography)(({ theme }) => ({
  color: theme.palette.neutral.white,
  marginBottom: theme.spacing(1),
}));

export const DetailValue = styled(Typography)(({ theme }) => ({
  color: theme.palette.neutral.white,
  fontWeight: 400,
  marginBottom: theme.spacing(1),
}));

// Added style for vertical text
export const VerticalText = styled(Typography)`
  writing-mode: vertical-rl;
  transform: rotate(180deg);
  text-align: center;
  font-size: 14px;
  font-weight: 700;
`;

export const StyledBox = styled(Box)`
  display: flex;
  flex-direction: column;
  margin-left: 5px;
`;

export const useStyles = (isOpen: boolean) => {
  return {
    buttonStyles: {
      position: isOpen ? ("absolute" as const) : ("fixed" as const),
      left: isOpen ? "-30px" : "auto",
      right: isOpen ? "auto" : "0",
      padding: "0px",
      top: "50%",
      transform: "translateY(-50%)",
      zIndex: 1000,
      border: "none",
      borderRadius: "8px 0 0 8px",
      minWidth: "10px",
      width: "30px",
      height: "150px",
      display: "flex",
      flexDirection: "column" as const,
      cursor: "pointer",
      transition: "all 0.3s ease",
    },
    arrowStyles: {
      fontSize: "14px",
      fontWeight: 700,
    },
  };
};
